import React, { useEffect } from "react"
import { useConsentGranted } from "./useConsent"
import { ANALYTICS_CONFIG } from "../../constants/analytics"

const GA4_SCRIPT_ID = "consent-ga4-loader"
const GA4_INIT_ID = "consent-ga4-init"
const GTM_SCRIPT_ID = "consent-gtm-loader"
const SEGMENT_SCRIPT_ID = "consent-segment-loader"

const injectGA4 = () => {
  if (typeof document === "undefined") return
  if (document.getElementById(GA4_SCRIPT_ID)) return

  const trackingId = ANALYTICS_CONFIG.GA4_TRACKING_ID

  const loader = document.createElement("script")
  loader.id = GA4_SCRIPT_ID
  loader.async = true
  loader.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`
  document.head.appendChild(loader)

  const init = document.createElement("script")
  init.id = GA4_INIT_ID
  init.text = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', '${trackingId}', { anonymize_ip: true, cookie_expires: 0 });
  `
  document.head.appendChild(init)
}

const injectGTM = () => {
  if (typeof document === "undefined" || typeof window === "undefined") return
  if (document.getElementById(GTM_SCRIPT_ID)) return

  const gtmId = ANALYTICS_CONFIG.GTM_ID

  const script = document.createElement("script")
  script.id = GTM_SCRIPT_ID
  script.text = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
    f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${gtmId}');
  `
  document.head.appendChild(script)

  const noscript = document.createElement("noscript")
  const iframe = document.createElement("iframe")
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`
  iframe.height = "0"
  iframe.width = "0"
  iframe.style.display = "none"
  iframe.style.visibility = "hidden"
  noscript.appendChild(iframe)
  document.body.insertBefore(noscript, document.body.firstChild)
}

const injectSegment = () => {
  if (typeof document === "undefined" || typeof window === "undefined") return
  if (document.getElementById(SEGMENT_SCRIPT_ID)) return

  const writeKey = ANALYTICS_CONFIG.SEGMENT_WRITE_KEY
  if (!writeKey) return

  const script = document.createElement("script")
  script.id = SEGMENT_SCRIPT_ID
  script.text = `
    !function(){var i="analytics",analytics=window[i]=window[i]||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","screen","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware","register"];analytics.factory=function(e){return function(){if(window[i].initialized)return window[i][e].apply(window[i],arguments);var n=Array.prototype.slice.call(arguments);if(["track","screen","alias","group","page","identify"].indexOf(e)>-1){var c=document.querySelector("link[rel='canonical']");n.push({__t:"bpc",c:c&&c.getAttribute("href")||void 0,p:location.pathname,u:location.href,s:location.search,t:document.title,r:document.referrer})}n.unshift(e);analytics.push(n);return analytics}};for(var n=0;n<analytics.methods.length;n++){var key=analytics.methods[n];analytics[key]=analytics.factory(key)}analytics.load=function(key,n){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.setAttribute("data-global-segment-analytics-key",i);t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r);analytics._loadOptions=n};analytics._writeKey="${writeKey}";analytics.SNIPPET_VERSION="5.2.0";
    analytics.load("${writeKey}");
    analytics.page();
    }}();
  `
  document.head.appendChild(script)
}

const ConsentLoader: React.FC = () => {
  const granted = useConsentGranted()

  useEffect(() => {
    if (granted.analytics) injectGA4()
  }, [granted.analytics])

  useEffect(() => {
    if (granted.marketing) {
      injectGTM()
      injectSegment()
    }
  }, [granted.marketing])

  return null
}

export default ConsentLoader
